import { useMemo } from 'react';
import { useSaSorgu } from './useSatisVerisi';
import type { SaKaynak } from './ekranKaynaklari';
import type { Donem } from './donem';

interface KanalSatiri {
  lokasyon: string;
}

/**
 * Sube listesi 040'in `lokasyon` kolonundan TURETILIR. Sorgu `sube: null, kanal: null` ile kurulur:
 * 040 ikisini de bildirmedigi icin anahtar KanalBlok/SubeBlok/OzetSerit'inkiyle AYNI -> ek istek yok.
 * `yuklendi`: liste gelmeden URL'deki sube "gecersiz" sayilmasin (yoksa once firma geneli istegi atilir).
 */
export function useSubeler(kaynak: SaKaynak | undefined, donem: Donem): { subeler: string[]; yuklendi: boolean } {
  const q = useSaSorgu<KanalSatiri>(kaynak, { donem, sube: null, kanal: null });

  const subeler = useMemo(() => {
    const kume = new Set<string>();
    for (const r of q.data?.data ?? []) {
      const ad = String(r.lokasyon ?? '').trim();
      if (ad) kume.add(ad);
    }
    return Array.from(kume).sort((a, b) => a.localeCompare(b, 'tr'));
  }, [q.data]);

  return { subeler, yuklendi: !kaynak || q.data !== undefined || q.isError };
}
